// URL shim for browser compatibility
// Some libraries check for url module but don't actually need it in browser

export const { URL } = globalThis;
export const { URLSearchParams } = globalThis;

export const fileURLToPath = (url) => {
    if (typeof url === 'string') {
        return url.replace('file://', '');
    }
    return url?.pathname || '';
};

export const pathToFileURL = path => new URL(`file://${path}`);

export const parse = (urlString) => {
    try {
        const url = new globalThis.URL(urlString);
        return {
            protocol: url.protocol,
            host: url.host,
            hostname: url.hostname,
            port: url.port,
            pathname: url.pathname,
            search: url.search,
            hash: url.hash,
            href: url.href,
        };
    } catch {
        return {};
    }
};

export const format = (urlObject) => {
    if (typeof urlObject === 'string') return urlObject;
    const { protocol, hostname, port, pathname, search, hash } = urlObject;
    return `${protocol}//${hostname}${port ? `:${ port}` : ''}${pathname || ''}${search || ''}${hash || ''}`;
};

export default {
    fileURLToPath,
    pathToFileURL,
    URL,
    URLSearchParams,
    parse,
    format,
};
